import { Generator as PaljsGenerator } from '@paljs/generator';
import {GenerateOpenCRUD} from "./OpenCRUD";

export default class Generator extends PaljsGenerator {
    constructor(...args) {
        super(...args);
        this.generators.openCRUD = new GenerateOpenCRUD(this.generator.schemaPath, this.options)
    }
}
